import styled from '@emotion/styled';
import FormLabel from '@mui/material/FormLabel';

const CustomFormLabel = styled(FormLabel)`
  font-size: 12px;
  font-weight: 500;
  color: var(--dk-text-secondary, #888d96);
  line-height: 18px;
`;

const Container = styled.div`
  font-family: var(--font-Pretendard);
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SubContainer = styled.div`
  margin-bottom: 10px;
`;

export { CustomFormLabel, Container, SubContainer };
